import { createEvent } from 'effector'

export const init = createEvent()

export const reset = createEvent()
